const BT50_PARTY_ABBREVIATIONS: Record<string, string> = {
  D: 'Democratic',
  R: 'Republican',
  GOP: 'Republican',
  I: 'Independent',
  L: 'Libertarian',
}

/**
 * Maps BillTrack50 / CSV single-letter party codes to display names (e.g. D → Democratic).
 * Already-expanded values and unknown codes are returned trimmed, unchanged.
 */
export function formatBt50PartyAbbreviation(party: string | null | undefined): string {
  const trimmed = (party ?? '').trim()
  if (trimmed.length === 0) {
    return ''
  }

  const mapped = BT50_PARTY_ABBREVIATIONS[trimmed.toUpperCase()]
  if (mapped) {
    return mapped
  }

  return trimmed
}

/**
 * Short role label for legislator cards (e.g. US Representative → Representative).
 */
export function formatLegislatorRoleTitle(role: string | null | undefined): string {
  const trimmed = (role ?? '').trim()
  if (trimmed.length === 0) {
    return 'Legislator'
  }

  const lower = trimmed.toLowerCase()
  if (lower.includes('senator')) {
    return 'Senator'
  }
  if (
    lower.includes('representative') ||
    lower.includes('delegate') ||
    lower.includes('resident commissioner')
  ) {
    return 'Representative'
  }

  return trimmed
}

/**
 * Builds the subtitle shown on politician cards: party, role, and optional state code.
 */
export function formatLegislatorCardSubtitle(options: {
  party: string | null | undefined
  role: string | null | undefined
  stateCode: string | null | undefined
}): string {
  const partyLabel = formatBt50PartyAbbreviation(options.party)
  const roleLabel = formatLegislatorRoleTitle(options.role)
  const stateCode = (options.stateCode ?? '').trim()

  const headline = [partyLabel, roleLabel].filter(Boolean).join(' ')
  if (!stateCode) {
    return headline
  }

  return `${headline} (${stateCode})`
}
